module.exports = __webpack_public_path__ + "img/wawa_slide_1.0d9b4cf3.jpg";